import { AppContext } from '@lightspeed-invoicing/core-client/frontend';
import React, { Component } from 'react';
import { FormattedDate, FormattedMessage, FormattedNumber } from 'react-intl';
import { Link, Redirect } from 'react-router-dom';
import EventBus from "../common/EventBus.js";
import GlobalHelper from '../common/GlobalHelper.jsx';
import Icon from "../common/icon/icon.component.jsx";
import StandardList from '../common/listing/list.component.jsx';
import Pagination from "../common/listing/pagination.component.jsx";
import ButtonWrapper from '../common/rich-text/feature-protection-wrappers/buttonProtectionWrapper.component';
import InvoiceDueDate from "../invoice/duedate.component.jsx";
import NewInvoiceModal from "../invoice/newmodal.component.jsx";
import ReceivePaymentModal from "../invoice/receivepaymentmodal.component.jsx";
import InvoiceStatusBadge from "../invoice/status.component.jsx";

class InvoiceListByContact extends Component {

    constructor(props, context) {
        super(props, context)

        const contactId = this.props.contactId || ''
        this.state = {
            contactId: contactId,
            contactType: '',
            customerName: this.props.customerName || '',
            customerAccountIds: [],
            headers: [],
            rows: [],
            activePage: 1,
            pageSize: 10,
            totalItemsCount: 0,
            customerAccount: null,
            noEmployee: false,
            modal: '',
            accountLimit: null,
        }
        this.handlePageChange = this.handlePageChange.bind(this)
        this.receivePayment = this.receivePayment.bind(this)
        this.handleCloseAndRefresh = this.handleCloseAndRefresh.bind(this)
        this.openInvoiceCreationModal = this.openInvoiceCreationModal.bind(this)
        this.closeInvoiceCreationModal = this.closeInvoiceCreationModal.bind(this)
        this.refreshCustomerAccount = this.refreshCustomerAccount.bind(this)
        this.loadInvoicesByContactId = this.loadInvoicesByContactId.bind(this)
        this.refreshInvoiceList = this.refreshInvoiceList.bind(this)
    }

    componentDidMount() {
        AppContext.getApiClient().get('/account-limits').then(res => {
            this.setState({
                accountLimit: res,
            })
        })

        if (this.state.contactId) {
            this.refreshCustomerAccount(this.state.contactId)
        }
    }
    componentWillReceiveProps(nextProps) {
        this.refreshCustomerAccount(nextProps.contactId)
    }

    refreshCustomerAccount(contactId) {
        if (!contactId) {
            contactId = this.state.contactId
        }
        AppContext.getApiClient().get('/customer-accounts/' + contactId).then(res => {
            if (res.error) {
                return
            }
            const noEmployee = res.attributes.contact.type === 'organizations' && !res.attributes.contact.attributes.primaryContactId
            this.setState({
                customerAccount: res,
                noEmployee: noEmployee,
                contactId: contactId,
                customerAccountIds: res.attributes.customerAccountIds || [],
                contactType: res.attributes.contactType || '',
            }, this.loadInvoicesByContactId)
            EventBus.dispatch(EventBus.TopicCustomerBalanceUpdate, {})
        })
    }

    headers() {
        let headers = [
            <FormattedMessage
                id="customers.invoices.list.headers.id_label"
                defaultMessage="ID"
            />,
        ]
        if (this.state.contactType === 'organizations') {
            headers.push(<FormattedMessage
                id="customers.invoices.list.headers.employee_label"
                defaultMessage="Employee"
            />)
        }
        headers = headers.concat([
            <FormattedMessage
                id="customers.invoices.list.headers.sent_date_label"
                defaultMessage="Sent date"
            />,
            <FormattedMessage
                id="customers.invoices.list.headers.due_date_label"
                defaultMessage="Due date"
            />,
            <FormattedMessage
                id="customers.invoices.list.headers.status_label"
                defaultMessage="Status"
            />,
            <FormattedMessage
                id="customers.invoices.list.headers.amount_label"
                defaultMessage="Amount"
            />,
        ])
        return headers
    }

    row(invoice) {
        let rows = [
            <span>
                <Link to={'/invoices/' + invoice.id + '/edit'}>
                    {invoice.identifier}
                </Link>
                <small className={'ml-2'}>{invoice.poNumber}</small>
            </span>,
        ]
        if (this.state.contactType === 'organizations') {
            rows.push(invoice.contact ?
                <Link className={invoice.contact.isArchived ? "text-danger" : ""} to={'/contacts/' + invoice.contactId + '/details'}>
                    {invoice.contact.name}
                </Link> : '-')
        }
        rows = rows.concat([
            <span>
                {invoice.sentAt ? <FormattedDate
                    year='numeric'
                    month='long'
                    day='numeric'
                    value={new Date(invoice.sentAt)} /> :
                    "-"}
            </span>,
            (invoice.billingType !== 'return') ? <InvoiceDueDate
                value={invoice.dueDate}
                status={invoice.status}
            /> : '-',
            <InvoiceStatusBadge
                status={invoice.status}
            />,
            <FormattedNumber
                style="currency"
                currency={invoice.currency}
                value={invoice.totalAmount}
            />,
        ])
        return rows
    }

    loadInvoicesByContactId() {
        let postData = {
            keywords: '*',
            objects: ['invoices'],
            fields: ['identifier', 'contact.name'],
            pageSize: this.state.pageSize,
            activePage: this.state.activePage,
            sortByField: 'createdAt',
            sortAsc: false,
            filters: {
                contactId: this.state.customerAccountIds,
                billingType: ['one-time', 'return']
            },
            lightResult: true,
        }

        AppContext.getApiClient().post('/listing/search', postData).then(r => {
            this.setState({
                headers: r.data.length > 0 ? this.headers() : [],
                rows: r.data.map(q => this.row(q)),
                loading: false,
                totalItemsCount: r.metadata.totalItemsCount,
            })
        })
    }

    refreshInvoiceList() {
        this.setState({
            activePage: 1,
        }, this.loadInvoicesByContactId)
    }

    handlePageChange(pageNumber) {
        this.setState({
            activePage: pageNumber
        }, this.loadInvoicesByContactId)
    }

    handleCloseAndRefresh() {
        this.setState({
            modal: ''
        })
        this.refreshCustomerAccount(this.state.contactId)
        setTimeout(this.refreshCustomerAccount, 2000)
        EventBus.dispatch(EventBus.TopicRefreshCustomerDetails, {
            contactId: this.state.contactId,
        })
    }

    receivePayment(event) {
        event.preventDefault()
        this.setState({
            modal: <ReceivePaymentModal
                onClose={this.handleCloseAndRefresh}
                customerAccount={this.state.customerAccount}
                customerName={this.state.customerAccount}
                contactId={this.state.contactId}
                customerAccountId={this.state.contactId}
            />
        })
    }

    openInvoiceCreationModal(event, isReturn) {
        event.preventDefault()

        let contactId = ""

        if (this.state.customerAccount?.attributes.contact?.type) {
            switch (this.state.customerAccount.attributes.contact.type) {
                case "organizations":
                    contactId = this.state.customerAccount.attributes.contact.attributes.primaryContactId
                    break
                case "persons":
                    contactId = this.state.contactId
                    break
                default:
                    return
            }
        }

        this.setState({
            modal: <NewInvoiceModal
                contactId={contactId || ""}
                onClose={this.closeInvoiceCreationModal}
                isReturn={isReturn}
            />
        })
    }

    closeInvoiceCreationModal(invoiceId) {
        this.setState({
            modal: invoiceId ? <Redirect to={'/invoices/' + invoiceId + '/edit'} /> : ''
        })
    }

    owingBalanceIsOverCreditLimit() {
        if (!this.state.customerAccount) {
            return false
        } else if (parseFloat(this.state.customerAccount.attributes.contact.attributes.creditLimit) === 0) {
            return false
        }

        return parseFloat(this.state.customerAccount.attributes.owingBalance) >
            parseFloat(this.state.customerAccount.attributes.contact.attributes.creditLimit)
    }

    render() {
        if (this.state.rows.length < 0) {
            return <div />
        }
        return (
            <div>
                {this.state.modal}
                <StandardList
                    smallLine={true}
                    className="row pt-0"
                    headers={this.state.headers}
                    rows={this.state.rows}
                    footer={<div className="col-12 d-flex d-flex justify-content-between align-items-center">
                        <div>
                            <Pagination
                                className={'px-2'}
                                activePage={this.state.activePage}
                                pageSize={this.state.pageSize}
                                totalItemsCount={this.state.totalItemsCount}
                                onChange={this.handlePageChange}
                            />
                        </div>
                        <div>
                            {
                                this.state.customerAccount && parseFloat(this.state.customerAccount.attributes.owingBalance) > 0 ?
                                    <span className={'mr-2'}>
                                        <button className="btn btn-success btn-sm" onClick={this.receivePayment}>
                                            <Icon value={'dollar-sign'} />
                                            <FormattedMessage
                                                id="customers.invoices.list.receive_payment_btn"
                                                defaultMessage="Receive payments"
                                            />
                                        </button>
                                    </span> : ''
                            }

                            {!this.state.noEmployee ? <button className="btn btn-warning btn-sm mr-2" onClick={(e) => this.openInvoiceCreationModal(e, true)}>
                                <Icon value={'plus-circle'} className={'mr-1'} />
                                <FormattedMessage
                                    id="customers.returns.list.new_return_btn"
                                    defaultMessage="Create a new return"
                                />
                            </button> : null}
                            {!this.state.noEmployee && this.state.accountLimit ?
                                <ButtonWrapper
                                    message={GlobalHelper.isAccountLimitExceeded(this.state.accountLimit) ?
                                        <FormattedMessage
                                            id="listing.search.invoice_document_limit"
                                            defaultMessage="Documents limit exceeded."
                                        /> : ''}
                                    onClick={(e) => this.openInvoiceCreationModal(e, false)}
                                    className={"btn btn-primary btn-sm"}
                                    protectedClassName={"btn btn-primary btn-sm"}
                                    premium={false}
                                    protectionRule={!GlobalHelper.isAccountLimitExceeded(this.state.accountLimit)}>
                                    <Icon value={'plus-circle'} className={'mr-1'} />
                                    <FormattedMessage
                                        id="customers.invoices.list.new_invoice_btn"
                                        defaultMessage="Create a new invoice"
                                    />
                                </ButtonWrapper>
                                : null}
                        </div>
                    </div>}
                />
            </div>

        );
    }
}

export default InvoiceListByContact





// WEBPACK FOOTER //
// ./src/customer/invoicelist.component.jsx